import {NgModule} from '@angular/core';
import {ConfirmationAlertComponent} from './confirmation-alert.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [
    ConfirmationAlertComponent,
  ],
  exports: [
    ConfirmationAlertComponent,
  ]
})
export class ConfirmationAlertModule {
}
